window.addEventListener("load", (e) => {
  setTimeout(function () {
    var style = document.createElement("style");
    style.innerHTML = `[bss-b2b-variant-price]:not([bss-b2b-product-active]),[bss-b2b-product-price]:not([bss-b2b-product-active]),[bss-b2b-cart-item-key][bss-b2b-item-original-price],[bss-b2b-cart-item-key][bss-b2b-final-line-price],[bss-b2b-cart-item-key][bss-b2b-item-original-price],[bss-b2b-cart-item-key][bss-b2b-final-line-price],[bss-b2b-cart-total-price]{visibility:visible!important}[bss-b2b-variant-price]:not([bss-b2b-product-active]).money,[bss-b2b-product-price]:not([bss-b2b-product-active]).money{font-size:20px!important}`;
    document.head.appendChild(style);
  }, 1000);
  document.addEventListener("BSS:filterCollection", (e) => {
    setTimeout(() => {
      if (!window.BSS_B2B?.observer?.productSubject) return;
      BSS_B2B.observer.productSubject.notifyObserver(
        "LazyProduct",
        "ProductPriceMutate"
      );
    }, 700);
  });
});
const isCartPage = window.location.pathname === "/cart";
if (isCartPage) {
  let counter = 0;
  const selector = ".ajax-cart__button-submit";
  const interval = setInterval(() => {
    const element = document.querySelector(selector);
    if (element !== null) {
      setTimeout(() => {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
      }, 500);
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}


const buttons = document.querySelectorAll(".product-listing__quickview-trigger");

buttons.forEach((btn) => {
  btn.addEventListener("click", () => {
    setTimeout(() => {
      document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    },1000)
  });
});